export default __webpack_public_path__ + "static/media/sourav-dada.b55e291b.png";